/* ============================================================================
   CM-MEGA - comportamiento del panel «INDICE DE PLANTA» (12 oct 2026)
   - Las fotos no se piden hasta la primera apertura (data-src -> src).
   - Archivo (la tipografia de los nombres) solo la carga la portada; aqui se
     pide en cuanto el raton entra en la cabecera, antes de abrir el panel.
   - Raton o foco sobre una entrada: manda esa entrada (rodillo, visor con
     cortina y sus tres piezas).
   La apertura y el cierre los sigue llevando cm-mezcla.js; esto no la toca.
   ========================================================================== */
(function () {
  'use strict';
  var panels = document.querySelectorAll('[data-cmm]');
  if (!panels.length) return;
  document.body.classList.add('cmm-on');

  var FONT = 'https://fonts.googleapis.com/css2?family=Archivo:wdth,wght@62..125,400..900&display=swap';
  var fontAsked = false;
  function pedirFuente() {
    if (fontAsked) return;
    fontAsked = true;
    if (document.querySelector('link[href^="https://fonts.googleapis.com/css2?family=Archivo"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = FONT;
    document.head.appendChild(l);
  }

  Array.prototype.forEach.call(panels, function (panel) {
    var item = panel.closest('.cm-nav__item--has-sub');
    var header = panel.closest('header') || item;
    var list = panel.querySelector('.cmm__list');
    var rows = panel.querySelectorAll('.cmm__a');
    var figs = panel.querySelectorAll('.cmm__fig');
    var sets = panel.querySelectorAll('.cmm__set');
    var cur = 0, hydrated = false, readyT = 0;

    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      Array.prototype.forEach.call(panel.querySelectorAll('img[data-src]'), function (im) {
        if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
        im.src = im.getAttribute('data-src');
        im.removeAttribute('data-src');
        im.removeAttribute('data-srcset');
      });
    }

    function set(i) {
      if (i === cur) return;
      var prev = cur;
      cur = i;
      for (var r = 0; r < rows.length; r++) rows[r].classList.toggle('is-on', r === i);
      for (var f = 0; f < figs.length; f++) {
        var fg = figs[f];
        if (f === i) {
          fg.classList.remove('is-was', 'is-on');
          void fg.offsetWidth;               /* reinicia la cortina */
          fg.classList.add('is-on');
        } else if (f === prev) {
          fg.classList.remove('is-on');
          fg.classList.add('is-was');
        } else {
          fg.classList.remove('is-on', 'is-was');
        }
      }
      for (var s = 0; s < sets.length; s++) sets[s].classList.toggle('is-on', s === i);
    }

    function desdeEvento(e) {
      var a = e.target.closest && e.target.closest('.cmm__a');
      if (!a || !panel.contains(a)) return;
      var i = parseInt(a.getAttribute('data-cmm-i'), 10);
      if (!isNaN(i)) set(i);
    }

    if (header) header.addEventListener('pointerenter', pedirFuente, { passive: true });
    if (item) {
      item.addEventListener('pointerenter', function () {
        hydrate();
        clearTimeout(readyT);
        readyT = setTimeout(function () { panel.classList.add('is-ready'); }, 900);
      }, { passive: true });
      item.addEventListener('focusin', function () { pedirFuente(); hydrate(); panel.classList.add('is-ready'); });
      item.addEventListener('pointerleave', function () {
        clearTimeout(readyT);
        panel.classList.remove('is-ready');
      }, { passive: true });
    }
    panel.addEventListener('mouseover', desdeEvento, { passive: true });
    panel.addEventListener('focusin', desdeEvento);
    if (list) {
      list.addEventListener('pointerenter', function () { list.classList.add('is-hov'); }, { passive: true });
      list.addEventListener('pointerleave', function () { list.classList.remove('is-hov'); }, { passive: true });
    }
  });
})();

/* ============================================================================
   MENU MOVIL «INDICE» (13 oct 2026). La apertura la sigue llevando
   cm-terrace.js (hamburguesa -> `.cm-menu.is-open`); aqui solo:
   - colocar el panel justo debajo de la barra, midiendo (el mismo problema del
     panel de PC: con la pagina bajada el bloque contenedor del `fixed` no es
     la pantalla);
   - pedir las miniaturas la primera vez que se abre;
   - quitar el escalonado de la entrada cuando ya ha terminado.
   ========================================================================== */
(function () {
  'use strict';
  var panel = document.querySelector('.cm-menu.cmm-mpanel');
  if (!panel) return;
  var header = panel.closest('.cm-header') || document.querySelector('.cm-header');
  var bar = header && (header.querySelector('.cm-header__bar') || header);
  var burger = header && header.querySelector('[data-cm-burger]');
  if (!bar || !burger) return;
  var hydrated = false, readyT = 0;

  function colocar() {
    var hb = bar.getBoundingClientRect().bottom;
    panel.style.setProperty('--cmm-top', '0px');
    var cb = panel.getBoundingClientRect().top;
    panel.style.setProperty('--cmm-top', Math.round(hb - cb) + 'px');
    panel.style.height = Math.max(200, Math.round(window.innerHeight - hb)) + 'px';
  }
  function hydrate() {
    if (hydrated) return;
    hydrated = true;
    Array.prototype.forEach.call(panel.querySelectorAll('img[data-src]'), function (im) {
      if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
      im.src = im.getAttribute('data-src');
      im.removeAttribute('data-src');
      im.removeAttribute('data-srcset');
    });
  }
  burger.addEventListener('click', function () {
    requestAnimationFrame(function () {
      if (burger.getAttribute('aria-expanded') !== 'true') {
        clearTimeout(readyT);
        panel.classList.remove('is-ready');
        return;
      }
      colocar();
      hydrate();
      clearTimeout(readyT);
      readyT = setTimeout(function () { panel.classList.add('is-ready'); }, 1100);
    });
  });
  window.addEventListener('resize', function () {
    if (burger.getAttribute('aria-expanded') === 'true') colocar();
  }, { passive: true });
})();
